export const onDemandSchemaResponse = {
  "schema": {
      "timeline": {
          "regular": true,
          "startDate": 1704067200000,
          "endDate": 1735688400000,
          "frequency": 1200,
          "key": "Date/Time"
      },
      "vectors": [
          {
              "name": "Current Speed",
              "type": "current",
              "key": "spd",
              "units": "m/s",
              "directional": false,
              "order": 0,
              "mat_key": "Spd",
              "type_mat_key": "Current",
              "min": 0.0031477212905883789,
              "max": 0.891204833984375
          },
          {
              "name": "Current Direction",
              "type": "current",
              "key": "drr",
              "units": "deg True Towards",
              "directional": true,
              "order": 10,
              "mat_key": "Dir",
              "type_mat_key": "Current",
              "min": 0.011573482304811478,
              "max": 359.9942626953125
          },
          {
              "name": "Waterlevel",
              "type": "waterlevel",
              "key": "z",
              "units": "m relative to MSL",
              "directional": false,
              "order": 20,
              "mat_key": "z",
              "type_mat_key": "Waterlevel",
              "min": -2.6431870460510254,
              "max": 2.5127854347229004
          }
      ],
      "description": {
          "key": "mow-ondemand-europe-1",
          "model": "ondemand",
          "provider": "mow",
          "geography": "europe",
          "version": "1",
          "uid": "7:preview",
          "filename": "M54125N001235W",
          "lat": 54.125,
          "lon": -1.235,
          "sqm": 0.000025,
          "wkb_geometry": "MULTIPOLYGON(((-1.2375 54.1225,-1.2325 54.1225,-1.2325 54.1275,-1.2375 54.1275,-1.2375 54.1225)))",
          "depth": 32.416000366210938,
          "label": "On-Demand",
          "description": "**On-Demand European data.**",
          "datum": "MSL"
      },
      "storedPaths": []
  }
}